import { NavLink } from 'react-router-dom';

/** The IVR Management pages, each at its own address (/admin/ivr/<page>). */
export const IVR_PAGES = [
  { path: 'field-inputs', label: 'Field Inputs' },
  { path: 'category-assignment', label: 'Category Assignment' },
  { path: 'menu-messages', label: 'Menu Messages' },
  { path: 'character-recordings', label: 'Character Recordings' },
  { path: 'simcha-week', label: 'Simcha Week Calendar' },
  { path: 'names', label: 'Names' },
  { path: 'titles', label: 'Titles' },
  { path: 'places', label: 'Places' },
  { path: 'weeks-and-days', label: 'Weeks & Days' },
  { path: 'letters', label: 'Letters' },
];

/** Shared navigation between the IVR pages; scrolls sideways on a phone instead of wrapping. */
export function IvrNav() {
  return (
    <nav aria-label="IVR pages" className="-mx-1 mb-6 overflow-x-auto">
      <ul className="flex gap-1 px-1 pb-1 min-w-max">
        {IVR_PAGES.map((p) => (
          <li key={p.path}>
            <NavLink
              to={`/admin/ivr/${p.path}`}
              className={({ isActive }) =>
                `block whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive ? 'bg-ink text-white font-medium' : 'bg-white text-ink/70 hover:bg-ink/5 border border-ink/10'
                }`
              }
            >
              {p.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
